namespace GeniuzPOS.Inventory {
    export namespace IcStockApproveDisassembleDtService {
        export const baseUrl = 'Inventory/IcStockApproveDisassembleDt';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcStockApproveDisassembleDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcStockApproveDisassembleDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Inventory/IcStockApproveDisassembleDt/Retrieve",
            List = "Inventory/IcStockApproveDisassembleDt/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcStockApproveDisassembleDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
